/* This file was generated automatically. Do not edit manually. */

export enum RoutingRuleAssignmentTargetType {
    CompanyAsDetails = 'CompanyAsDetails',
    CompanyAsOwner = 'CompanyAsOwner',
    NoCompany = 'NoCompany',
}
